import { IExecutionOptions, IQueryContext, IQueryContextEntity } from '../models/query';
import { Query } from './Query';
import { IQueryOptionsEntities } from '../models/query/options';
import { BaseEntityQuery } from './BaseEntityQuery';
import { ILinkedEntity } from '../models/api/search';

export class EntitiesQuery extends BaseEntityQuery<IQueryOptionsEntities> {
	getOptions(): IQueryOptionsEntities {
		const { entityConditional, entitiesOptions, options = {} } = this.queryOptions;
		const { childQuery } = entitiesOptions || {};
		return {
			entityConditional,
			childQuery,
			...(options.entities || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const context = Query.getContext(executionOptions, this.queryOptions);
		const entities = this.getEntities(executionOptions, context);
		const results: any[] = [];
		if (entities && entities.length > 0) {
			const { childQuery } = this.options;
			if (!childQuery) {
				// Default to return whole entity if no childQuery is defined.
				return entities as any;
			}

			const entitiesConfiguration = Query.getContextConfiguration(executionOptions, this.queryOptions);
			const { queryId } = this.queryOptions;
			let entityConfiguration: IQueryContextEntity;
			let linkedEntities: ILinkedEntity[];
			if (entitiesConfiguration) {
				entityConfiguration = entitiesConfiguration.entities.find(config => config.id === queryId);
				linkedEntities = entityConfiguration && entityConfiguration.linkedEntities;
			}
			const options = childQuery;
			if (!childQuery.entityType) {
				const entityType = entities[0].type;
				options.entityType = entityType;
			}
			const query = new Query(options, this.translationHelper);
			for (const entity of entities) {
				let result;
				let overridingContext: IQueryContext = {};
				const { entityKey } = options;
				if (linkedEntities && entityKey) {
					// Get the entityMap and entitiesById based on the base entity
					const { entityMap, entitiesById } = context.entities[queryId];
					const queryContextEntityMap = entityMap.get(entity.entityId);
					// Add this entity data to the entitiesById map
					entitiesById.set(entity.entityId, entity);
					// Add this entityId to the entityMap
					const entityId: Set<number> = new Set([entity.entityId]);
					const overridingEntityMap = {
						...queryContextEntityMap,
						[entityConfiguration.id]: entityId,
					};
					overridingContext = {
						entitiesById,
						entityMap: overridingEntityMap,
					};
				}
				else {
					overridingContext = {
						...executionOptions.context,
						entityByType: {
							[options.entityType]: entity,
						},
					};
				}
				const workingExecutionOptions: IExecutionOptions = {
					...executionOptions,
					context: {
						...overridingContext,
					},
				};

				result = query.execute(workingExecutionOptions);
				if (result) {
					results.push(result);
				}
			}
		}
		return results as any;
	}
}